import { bind } from 'bind-decorator';
import React from 'react';
import Popover from '../../../../../../controls/modal/popover';
import Icons from '../../../../../../icons';

class Chip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      open: false
    };
  }

  @bind
  onClick(e) {
    e.preventDefault();
    this.setState({
      open: true,
      anchorEl: e.currentTarget
    });
  }
  @bind
  onClose(e) {
    this.setState({
      open: false,
      anchorEl: null
    });
  }

  @bind
  removeToken(token) {
    this.props.removeToken();
  }

  render() {
    var popoverStyle = {
      borderRadius: 25,
      fontSize: '13px',
      padding: '2px 10px'
    };

    let displayText = this.props.name != null ? this.props.name : this.props.email;

    var removeButton = (
      <div
        className="tokenDelete"
        onClick={this.removeToken.bind(this)}
        style={{
          marginLeft: 5,
          display: 'inline-block',
          cursor: 'pointer',
          position: 'relative',
          top: 3,
          paddingRight: 1
        }}
      >
        {Icons.customCancel}
      </div>
    );

    if (this.props.disabled) removeButton = '';

    return (
      <div style={{ display: 'inline-block' }}>
        <div onClick={this.onClick} style={{ paddingLeft: '5px', display: 'inline-block' }}>
          {displayText}
        </div>
        {removeButton}
        <Popover
          style={popoverStyle}
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.onClose}
        >
          <span>{this.props.email || '<No email address>'}</span>
        </Popover>
      </div>
    );
  }
}

Chip.defaultProps = {
  disabled: false
};

export default Chip;
